export const format = (store_credit): number => (store_credit || 0) / 1000

const storeCreditGetters = {
  format,
}

export default storeCreditGetters
